module.exports = __webpack_public_path__ + "img/reverse.e3bd8963.png";